<template>
    <div class="quickForm" :class="[isBorderRed ? 'quickFormItem-red' : '']">
        <el-form :model="formData" ref="ruleForm" :rules="rules">
            <div class="quick">
                <div class="quick-label">
                    <p>{{index + 1}}.{{domain.instant_app_name}}<br>{{domain.instant_app_id}}</p>
                </div>
                <div class="quick-con">
                    <el-form-item
                        prop="instant_app_url"
                    >
                        <el-input v-model="formData.instant_app_url" placeholder="请输入完整的快应用直达链接" style="width: 100%;" @input="handleInput"></el-input>
                    </el-form-item>
                    <el-form-item style="margin-bottom: 0;" class="quick-con-flex">
                        <el-form-item style="margin-bottom: 0;">
                            <ESelect v-model="formData.page_type" placeholder="请选择" style="width: 120px;" @change="(value)=>filterSubListType(value, domain)">
                                <el-option :label="paginate.name" :value="paginate.value" v-for="(paginate, pageindex) in page_select_options" :key="pageindex"></el-option>
                            </ESelect>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0;flex: 1;"
                                      prop="page_url"
                        >
                            <el-input v-if="page_select_options[currentIndex] && page_select_options[currentIndex].sub_list_type == 'content'" v-model="formData.page_url" placeholder="请输入完整的打底网页URL地址" style="width: 100%;" @input="handleInputUrl"></el-input>
                            <ESelect v-if="page_select_options[currentIndex] && page_select_options[currentIndex].sub_list_type == 'select'" v-model="formData.page_id" @change="handelChange" placeholder="请选择" style="width: 100%;">
                                <el-option :label="item.pageName" :value="item.pageId" v-for="(item, subIndex) in page_select_options[currentIndex].sub_list" :key="subIndex"></el-option>
                            </ESelect>
                        </el-form-item>
                    </el-form-item>
                </div>
            </div>
        </el-form>
    </div>
</template>
<script >
export default {
    props: [ 'domain' ,'err_ids', 'index', 'page_select_options'],
    data() {
        const _this = this;
        let devalidator = (rule, value, callback) =>{

            if(this.isTemErr){
                const urlPattern = /^https:\/\/[^\s/$.?#].[^\s]*$/;
                const isValid = urlPattern.test(this.select_url);
                // console.log('1', this.select_url)
                // console.log('1', !isValid)
                if(this.select_url == '' || !isValid) {
                    callback(new Error("请输入完整的打底网页URL地址"));
                }else{
                    //校验通过
                    callback();
                }
            }else{
                //校验通过
                callback();
            }
        }
        return {
            formData: { ..._this.domain },
            isTemErr: false,
            rules: {
                instant_app_url: [
                    { required: true, message: '快应用名称(ID)直达链接为空无法验证', trigger: 'blur'},
                ],
                page_url:[
                    // { required: true, message: '请输入完整的URL地址', trigger: 'clear'},
                    { validator:devalidator, trigger: 'change'},
                ]
            },
            currentIndex: 0,
            isBorderRed: false,
            select_url: ''
        }
    },
    watch:{
      'err_ids': {
          handler(n) {
                  if(n.includes(this.formData.instant_app_id)) {
                      this.isBorderRed = true
                  }else{
                      this.isBorderRed = false
                  }
              },
              deep: true,
              immediate: true
          },
        'page_select_options': {
              handler(n) {
                  let curIndex = this.page_select_options.findIndex(item => item.sub_list.findIndex(itemc=> itemc.pageId == this.formData.page_id))
                  let curTypeSomeIndex = this.page_select_options.findIndex(item => item.value == this.formData.page_type)

                  if(curTypeSomeIndex === -1) {
                      // console.log('-------------a')
                      // 不存在 默认选择第一个
                      this.currentIndex = 0
                      // this.formData.page_type = this.page_select_options[0].value

                      this.select_url = ''
                      this.formData.page_id = ''

                      this.$nextTick(()=>{
                          this.formData.page_type = this.page_select_options[0].value
                          this.$refs.ruleForm.clearValidate(['page_url'])
                      })

                  }else{
                      // console.log('-------------1')
                      // 存在 重置currentIndex 的值  用value值去替换
                      this.currentIndex = curTypeSomeIndex

                      this.$nextTick(()=>{
                          this.formData.page_type = this.page_select_options[curTypeSomeIndex].value

                          if(this.page_select_options[this.currentIndex].sub_list_type == 'select') {
                              let curObj = this.page_select_options[this.currentIndex].sub_list.find(item => item.pageId == this.formData.page_id)
                              this.select_url = curObj ? curObj.pageUrl : ''
                              this.formData.page_id = curObj ? curObj.pageId : ''
                          }else{
                              this.select_url =  this.formData.page_url ? this.formData.page_url : ''
                          }
                      })

                  }

              },
            deep: true
        }
      },

    methods: {
        // 红色标记处理
        handleError(err) {
            this.isBorderRed = true
        },
        filterSubListType(value) {
            this.currentIndex = this.page_select_options.findIndex(item => item.value == value)
            if(this.page_select_options[this.currentIndex].sub_list_type == 'select') {
                let curObj = this.page_select_options[this.currentIndex].sub_list.find(item => item.pageId == this.formData.page_id)
                this.select_url = curObj ? curObj.pageUrl : ''
            }else{
                this.select_url = this.formData.page_url
            }
            this.$nextTick(()=>{
                this.$refs.ruleForm.clearValidate(['page_url'])
            })
        },
        handleInput(value) {
            this.$emit('changestatus')
        },
        handleInputUrl(value) {
            // console.log('v', value)
            this.select_url = this.formData.page_url
        },
        handelChange(value) {
            let curObj = this.page_select_options[this.currentIndex].sub_list.find(item => item.pageId == value)
            this.select_url = curObj ? curObj.pageUrl : ''

            this.$nextTick(()=>{
                this.$refs.ruleForm.clearValidate(['page_url'])
            })
        },
        async validateFn(status) {
            let new_url =  ''
            if(this.page_select_options[this.currentIndex].sub_list_type == 'content') {
                new_url = this.formData.page_url
            }else{
                new_url = this.select_url
            }

            if(status) {
                this.isTemErr = true
            }else{
                this.isTemErr = false
            }

            try {
                await this.$refs.ruleForm.validate();

                let res_params = {
                    instant_app_name: this.formData.instant_app_name,
                    instant_app_id:this.formData.instant_app_id,
                    instant_app_package:this.formData.instant_app_package,
                    instant_app_url: this.formData.instant_app_url,  //完整直达链接
                    page_url_info:{
                        page_type: this.formData.page_type,  // 自定义与下拉
                        page_url: new_url,  // 打底网页
                        page_id: this.formData.page_id,
                    },
                }
                return res_params
            }catch (err) {
                console.log(err, 'err')
                return Promise.reject('false')
            }

        }

    }
}
</script>
<style lang="scss" scoped>
.quickForm {
    .quick{
        display: flex;
        align-items: center;
        border: 1px solid #dadada;
        padding-top: 18px;
        padding-bottom: 18px;
        padding-right: 18px;
    }

    .quick-label{
        width: 140px;
        text-align: center;
    }
    .quick-con{
        flex: 1;
    }
    .quick-con-flex{
        ::v-deep>.el-form-item__content{
            display: flex;
        }
    }

}
.quickFormItem-red{
    .quick-label {
        color: red;
    }
}

</style>
